import PromptEmail from "@/src/components/home_components/PromptEmail.vue";
import PromptPhoneNumber from "@/src/components/home_components/PromptPhoneNumber.vue";
import PromptReason from "@/src/components/home_components/PromptReason.vue";
import PromptActions from "@/src/components/home_components/PromptActions.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

export const contactsHeader = {
  icon: "",
  size: "size-5",
  alt: "contacts_icon",
  title: "Contacts",
  description: "Added in last 30 days",
  emptyText: "No contacts found!",
};

export const companiesHeader = {
  icon: "",
  size: "size-5",
  alt: "companies_icon",
  title: "Companies",
  description: "Added in last 30 days",
  emptyText: "No companies found!",
};

export const dealsHeader = {
  icon: "",
  size: "size-5",
  alt: "deals_icon",
  title: "Deals",
  description: "My deals to be closed this month",
  emptyText: "No deals found!",
};

export const recommendedProspectHeaders = [
  {
    label: "Name",
    key: "name",
    width: 3,
    avatar: "photo_url",
    suffix: true,
    url: [{ key: "linkedin", image: imageNames.PROSPECTING_LINKEDIN_GREY }],
    clickable: true,
    redirectTo: (row) => {
      if (row.contact_id) {
        return { name: "contact-detail", params: { id: row.contact_id } };
      } else if (row.lead_id) {
        return { name: "lead-detail", params: { id: row.lead_id } };
      } else {
        return { name: "prospect-lead-detail", params: { id: row.id } };
      }
    },
  },
  { label: "Current Role", key: "current_role", width: 3 },
  {
    label: "Current Company",
    key: "current_company",
    width: 3,
    avatar: "logo_url",
    url: [
      { key: "company_linkedin", image: imageNames.PROSPECTING_LINKEDIN_GREY },
      { key: "website", image: imageNames.PROSPECTING_BROWSER_GREY },
    ],
  },
  { label: "Reason to Engage", key: "reason_to_engage", width: 2 },
  { label: "Email", key: "email", width: 2 },
  { label: "Phone Number", key: "phone_number", width: 3 },
  { label: "Action", key: "actions", width: 1 },
];

export const tasksHomeHeaders = [
  { label: "Name", key: "title", width: 6 },
  { label: "Assignees Entities", key: "assignee_names", width: 2, view: true },
  { label: "Priority", key: "priority", width: 2 },
  { label: "Due Date", key: "due_date", width: 2 },
];

export const recommendedCustomColumnRender = {
  email: {
    component: PromptEmail,
    props: (record) => ({
      row: record,
    }),
  },
  phone_number: {
    component: PromptPhoneNumber,
    props: (record) => ({
      row: record,
    }),
  },
  reason_to_engage: {
    component: PromptReason,
    props: (record) => ({
      row: record,
    }),
  },
  actions: {
    component: PromptActions,
    props: (record) => ({
      row: record,
      source: "recommended-leads",
    }),
  },
};

export const RECOMMENDED_PROSPECTS_STATUS_CODES = {
  TRY_LATER: "TRY_LATER",
  YOU_ADDED_ALL_THE_LEADS: "YOU_ADDED_ALL_THE_LEADS",
  NO_LEADS_AND_ICP: "No_leads_AND_ICP",
};
